// Цвет заметки зависит от статуса сохранения и того, своя она или чужая.
// Свои — янтарные: их можно перемещать и редактировать.
// Чужие — синие: доступны только для просмотра.
// Несохранённые (ошибка API) — красные, чтобы было видно, что нужно повторить отправку.
// Заливки полупрозрачные и достаточно светлые, чтобы текст PDF под ними
// оставался читаемым.

export interface NoteColor {
    /** Обводка фигур и фон точечного маркера */
    stroke: string;
    /** Полупрозрачная заливка фигур и подсветка текста */
    fill: string;
    /** Тёмный тон: подпись на белом фоне и ореол белой подписи в SVG */
    text: string;
}

export const OWN_NOTE_COLOR: NoteColor = {
    stroke: '#f59e0b',
    fill: 'rgba(251, 191, 36, 0.35)',
    text: '#92400E',
};

export const OTHER_NOTE_COLOR: NoteColor = {
    stroke: '#2563EB',
    fill: 'rgba(59, 130, 246, 0.28)',
    text: '#1E40AF',
};

export const FAILED_NOTE_COLOR: NoteColor = {
    stroke: '#dc2626',
    fill: 'rgba(239, 68, 68, 0.32)',
    text: '#991B1B',
};

export function noteColorFor(isOwn: boolean): NoteColor {
    return isOwn ? OWN_NOTE_COLOR : OTHER_NOTE_COLOR;
}

/** Учитывать persistStatus=failed — красная подсветка несохранённой заметки. */
export function noteColorForHighlight(isOwn: boolean, persistStatus?: 'saving' | 'failed'): NoteColor {
    if (persistStatus === 'failed') return FAILED_NOTE_COLOR;
    return noteColorFor(isOwn);
}
